import { useEffect, useState } from 'react';
import api from './api';
import Login from './Login';
import Dashboard from './Dashboard';
import AdminPage from './AdminPage';
import ResellerPage from './ResellerPage';
import VncViewer from './VncViewer';

function clearSession() {
  sessionStorage.removeItem('auth_token');
  sessionStorage.removeItem('auth_role');
  sessionStorage.removeItem('auth_name');
  sessionStorage.removeItem('auth_email');
}

export default function App() {
  const [token, setToken] = useState(() => sessionStorage.getItem('auth_token'));
  const [page, setPage] = useState('dashboard');
  const [selectedVm, setSelectedVm] = useState(null);
  const [consoleApi, setConsoleApi] = useState(null);
  const [returnPage, setReturnPage] = useState('dashboard');
  const [vncUrl, setVncUrl] = useState(null);
  const [secret, setSecret] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token || !selectedVm || !consoleApi) return;
    setError(null);
    setSecret(null);
    setVncUrl(null);

    api.get(consoleApi)
      .then(res => {
        if (!res.data.status) {
          setError('Failed to get console');
          return;
        }
        const wsBase = process.env.API_BASE_URL.replace(/^http(s?)/, 'ws$1');
        setSecret(res.data.secret);
        setVncUrl(`${wsBase}/VNC/${sessionStorage.getItem('auth_token')}/${res.data.console}`);
      })
      .catch(err => {
        if (err.response?.status === 401) {
          clearSession();
          setToken(null);
        } else {
          setError(err.message);
        }
      });
  }, [token, selectedVm, consoleApi]);

  const handleLogout = () => {
    clearSession();
    setToken(null);
    setSelectedVm(null);
    setConsoleApi(null);
    setPage('dashboard');
  };

  const handleConnect = (vm) => {
    setReturnPage('dashboard');
    setConsoleApi(`/Member/Console/${vm.vmid}`);
    setSelectedVm(vm);
  };

  const handleAdminConnect = (vm) => {
    setReturnPage('admin');
    setConsoleApi(`/Admin/VM/${vm.vmid}/Console`);
    setSelectedVm(vm);
    setPage('dashboard');
  };

  const handleDisconnect = () => {
    setSelectedVm(null);
    setConsoleApi(null);
    setSecret(null);
    setVncUrl(null);
    setPage(returnPage);
    setReturnPage('dashboard');
  };

  if (!token) return <Login onLogin={setToken} />;

  if (page === 'admin') {
    return <AdminPage onBack={() => setPage('dashboard')} onLogout={handleLogout} onConnect={handleAdminConnect} />;
  }

  if (page === 'reseller') {
    return <ResellerPage onBack={() => setPage('dashboard')} onLogout={handleLogout} />;
  }

  if (!selectedVm) {
    return <Dashboard onConnect={(vm) => handleConnect(vm)} onLogout={handleLogout} onAdmin={() => setPage('admin')} onReseller={() => setPage('reseller')} />;
  }

  if (error) return (
    <div style={{ color: '#fca5a5', padding: 24, fontFamily: 'monospace' }}>
      Error: {error} <button onClick={handleDisconnect} style={{ marginLeft: 12, color: '#93c5fd', background: 'none', border: 'none', cursor: 'pointer' }}>← Back</button>
    </div>
  );

  if (!vncUrl) return <div style={{ color: '#9ca3af', padding: 24, fontFamily: 'monospace' }}>Loading Console session...</div>;

  const handleReboot = () => returnPage === 'admin'
    ? api.put(`/Admin/VM/${selectedVm.vmid}/Reboot`)
    : api.put(`/Member/Reboot/${selectedVm.vmid}`);

  return <VncViewer url={vncUrl} password={secret} onDisconnect={handleDisconnect} onReboot={handleReboot} vmName={selectedVm?.name} />;
}
